import { sentimentVoice } from '../constants';

const initialState = {
  value: [],
  date: [],
  name: '',
  isFetching: false,
  isFetched: false
};

export function widgetSentiment(state = initialState, action) {
  switch (action.type) {
    case sentimentVoice.REQUEST:
      return {
        ...state,
        isFetching: true,
        isFetched: false,
        lastUpdated: action.receivedAt };
    case sentimentVoice.RECEIVE:
      return {
        ...state,
        value: action.value,
        tagCounts: action.tagCounts,
        name: action.name,
        date: action.date, // use positive date to be xAxis
        isFetching: false,
        isFetched: true,
        lastUpdated: action.receivedAt
      };
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/widgetSentiment.reducer.js